import { BookOpen, Globe2, Compass } from "lucide-react";

/**
 * explain/constants.js — Iter84 extraction.
 *
 * Static config used across the ExplainDeeperSheet and its sub-components.
 * Pulled out so the orchestrator file doesn't carry a 30-line BCP-47
 * mapping it never mutates.
 */

export const PARTS = [
  { n: 1, title: "Advanced Theory & Mechanics",            Icon: BookOpen, accent: "text-[#8aa8ff]" },
  { n: 2, title: "Case Studies & Real-World Applications", Icon: Globe2,   accent: "text-[#00FF9D]" },
  { n: 3, title: "Strategic Execution & Future Trends",    Icon: Compass,  accent: "text-[#ffb067]" },
];

export const READING_WPM = 230;

// Map our internal 2-letter language codes (e.g. "de", "fr") to the
// BCP-47 region tags SpeechSynthesisUtterance.lang expects (e.g.
// "de-DE", "fr-FR"). Without this mapping the browser picks the user's
// system locale and a German path gets narrated by an English voice
// reading German words phonetically — sounds awful.
const _LANG_BCP47 = {
  en: "en-US",
  de: "de-DE",
  fr: "fr-FR",
  es: "es-ES",
  it: "it-IT",
  pt: "pt-PT",
  nl: "nl-NL",
  pl: "pl-PL",
  ru: "ru-RU",
  ja: "ja-JP",
  ko: "ko-KR",
  zh: "zh-CN",
  hi: "hi-IN",
  ar: "ar-SA",
  tr: "tr-TR",
  sv: "sv-SE",
  no: "nb-NO",
  da: "da-DK",
  fi: "fi-FI",
  uk: "uk-UA",
  he: "he-IL",
  th: "th-TH",
  vi: "vi-VN",
  id: "id-ID",
};

export function langToBcp47(code) {
  if (!code) return "en-US";
  const lc = String(code).toLowerCase();
  if (lc.includes("-")) return lc;
  return _LANG_BCP47[lc] || `${lc}-${lc.toUpperCase()}`;
}
